import { Injectable } from "@angular/core";
import { FormGroup, FormControl, ValidatorFn, AbstractControl } from "@angular/forms";
import { EntityFormModel } from "@app/kernel/form/classes/entity-form-model";
import { IUpdatePasswordControls, IUpdatePasswordFormValue, IUpdatePasswordDto } from "../interfaces/update-password.interface";

@Injectable()
export class UpdatePasswordFormModel extends EntityFormModel<object, IUpdatePasswordFormValue, IUpdatePasswordControls> {
  constructor() {
    super();
  }

  entityToFormValue(): IUpdatePasswordFormValue {
    return {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    };
  }

  formValueToDtoInput(formValue: IUpdatePasswordFormValue): IUpdatePasswordFormValue {
    return formValue;
  }

  // Separate helper: only send oldPassword and password to backend
  getDtoForBackend(): IUpdatePasswordDto {
    const { oldPassword, newPassword } = this.formGroup().getRawValue();
    return { oldPassword, newPassword };
  }

  // Build form group with controls
  protected createFormGroup(initialValue: IUpdatePasswordFormValue): FormGroup<IUpdatePasswordControls> {
    const group = new FormGroup<IUpdatePasswordControls>({
      oldPassword: new FormControl(initialValue.oldPassword, {
        nonNullable: true,
        validators: [this.buildValidator(() => ({ isNotEmpty: {} }))],
      }),
      newPassword: new FormControl(initialValue.newPassword, {
        nonNullable: true,
        validators: [this.buildValidator(() => ({ isNotEmpty: {}, isStrongPassword: {} }))],
      }),
      confirmPassword: new FormControl(initialValue.confirmPassword, {
        nonNullable: true,
        validators: [this.buildValidator(() => ({ isNotEmpty: {} })), this.passwordMatchValidator()],
      }),
    });
    return group;
  }
  private passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const formGroup = control.parent;
      if (!formGroup) return null;
      const password = formGroup.get("newPassword")?.value;
      const confirmPassword = control.value;
      return password === confirmPassword ? null : { passwordMismatch: true };
    };
  }
}
